'use client';

import React from 'react';
import ReactHtmlParser from '@libs/reactHtmlParser';
import Link from 'next/link';
import cn from './style.module.scss';

type IslandCommonButtonProps = {
  t?: any;
  className?: string;
  labelKey?: string;
  label?: string;
  link?: string;
};

const normalizeUrl = (url: string): string => {
  const basePath = process.env.NEXT_PUBLIC_APP_HOMEPAGE || '';
  if (!basePath || !url.startsWith(`/${basePath}`)) return url;
  return url.slice(`/${basePath}`.length) || '/';
};

export default function IslandCommonButton({
  t,
  className,
  labelKey,
  label,
  link,
}: IslandCommonButtonProps) {
  const handleRegisterScroll = () => {
    const element = document.getElementById('fahid-island-registration');
    element?.scrollIntoView({ behavior: 'smooth' });
  };
  const buttonLabel = labelKey || label || t?.islandRegisterButton || '';
  if (link) {
    return (
      <Link
        href={normalizeUrl(link)}
        className={`${cn.islandCommonButton} ${className ?? ''}`}
      >
        {ReactHtmlParser(buttonLabel)}
      </Link>
    );
  }
  return (
    <button
      type="button"
      onClick={handleRegisterScroll}
      className={`${cn.islandCommonButton} ${className ?? ''}`}
    >
      {ReactHtmlParser(buttonLabel)}
    </button>
  );
}
